import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Button } from "@/src/components/ui/button"
import { useEffect } from "react"
import { useAuth } from "@/src/components/AuthContextProvider"

export const Route = createFileRoute('/_auth/logout')({
  component: LogoutPage,
})

function LogoutPage() {
  const navigate = useNavigate()
  const { signOut } = useAuth()

  useEffect(() => {
    // Clear localStorage, sessionStorage, and cookies
    if (typeof window !== "undefined") {
      localStorage.clear()
      sessionStorage.clear()
      // Remove all cookies
      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)
      })
    }
    // Perform sign out and redirect to login
    ;(async () => {
      await signOut()
      navigate({ to: "/login" })
    })()
  }, [navigate, signOut])

  return (
    <div className="text-center">
      <h2 className="mb-4 text-2xl font-bold text-foreground">You have been logged out</h2>
      <p className="text-muted-foreground mb-6">
        Thank you for using GearLens. You have been successfully signed out.
      </p>
      <Button className="bg-primary text-primary-foreground hover:bg-primary/90 w-full" onClick={() => navigate({ to: "/login" })}>Back to Login</Button>
    </div>
  )
}
